import type { SocialCanvasElement, SocialCanvasElementType } from '../../../services/socialPosting';

// Re-export the types from the service for convenience
export type {
  SocialCanvasElement,
  SocialCanvasElementType,
  SocialTextElement,
  SocialImageElement,
  SocialRectElement,
  SocialCircleElement,
} from '../../../services/socialPosting';

export type { SocialPostDesign, SocialPostProduct } from '../../../services/socialPosting';

// ── Default element factories ────────────────────────────────

let nextId = 1;

function generateId(): string {
  return `el_${Date.now()}_${nextId++}`;
}

export function createDefaultElement(type: SocialCanvasElementType): SocialCanvasElement {
  const base = { x: 50, y: 50, width: 200, height: 100, id: generateId(), visible: true, opacity: 1 };

  switch (type) {
    case 'text':
      return {
        ...base,
        type: 'text',
        name: 'Text',
        content: 'Text',
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Inter, sans-serif',
        color: '#000000',
        textAlign: 'left',
        letterSpacing: 0,
        lineHeight: 1.3,
        textTransform: 'none',
      };
    case 'image':
      return {
        ...base,
        type: 'image',
        name: 'Image',
        src: '',
        objectFit: 'cover',
        borderRadius: 0,
        removeBg: false,
      };
    case 'rect':
      return {
        ...base,
        type: 'rect',
        name: 'Rectangle',
        fill: '#e2e8f0',
        borderRadius: 0,
        border: '',
      };
    case 'circle':
      return {
        ...base,
        width: 100,
        height: 100,
        type: 'circle',
        name: 'Circle',
        fill: '#e2e8f0',
      };
  }
}
